import { createContext } from 'react'

const adminAuthContext = createContext()

export default adminAuthContext
